import React from "react";
import { Online, Offline } from "react-detect-offline";

function CheckOffline() {
  return (
    <div>
      <Offline>
        <div className="connection-panel">
          <p className="connection-text">{'No internet connection'}</p>
        </div>
      </Offline>
    </div>
  );
}

export default CheckOffline;
